import React, { useEffect, useRef } from 'react';
import { TextField } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

interface BorrowerNameFieldProps {
  borrowerId: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
}

const BorrowerNameField: React.FC<BorrowerNameFieldProps> = ({ 
  borrowerId, 
  name, 
  onChange, 
  error, 
  helperText 
}) => {
  const { control, setValue } = useForm({
    defaultValues: {
      [borrowerId]: name
    }
  });
  
  const hookFormActive = useRef(true);
  
  useEffect(() => {
    if (!hookFormActive.current) {
      setValue(borrowerId, name);
    }
  }, [name, borrowerId, setValue]);
  
  return (
    <Controller
      name={borrowerId}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          label="Name"
          fullWidth
          required
          size="small"
          autoComplete="off"
          error={error}
          helperText={helperText}
          sx={{ 
            '& .MuiInputBase-root': { 
              height: '36px'
            },
            '& .MuiOutlinedInput-input': {
              padding: '8px 14px',
              height: '20px',
              boxSizing: 'border-box'
            },
            '& .MuiInputLabel-root': {
              fontSize: '0.85rem',
              transform: 'translate(14px, 9px) scale(1)'
            },
            '& .MuiInputLabel-shrink': {
              transform: 'translate(14px, -6px) scale(0.75)'
            }
          }}
          onChange={(e) => {
            hookFormActive.current = true;
            field.onChange(e);
            const syntheticEvent = {
              ...e,
              target: e.target as HTMLInputElement
            } as React.ChangeEvent<HTMLInputElement>;
            onChange(syntheticEvent);
            setTimeout(() => {
              hookFormActive.current = false;
            }, 0);
          }}
        />
      )}
    />
  );
};

export default React.memo(BorrowerNameField);
